import React, { Fragment, useEffect, useMemo, useState } from "react";
import { PlatformsAndSocials } from "../../../components/ui/profileSetup/links/PlatformsAndSocials";
import { useCategories } from "../../../hooks/apiHooks/useCategories";
import { useFormik } from "formik";
import { createOrUpdateCategoriesValues } from "../../../config/apisauce";
import { VERIFY_FACE_ID_KEY } from "../../../enums/profileSetupEnums";
import useNotiStack from "../../../hooks/useNotiStack";
import { EditProfileButtons } from "./EditProfileButtons";
import { formatCategoryValues, removeNullValues } from "../../../components/generic/functions/genericFunctions";

export const EditSocialsForm = ({ socialsValues, creatorDetails, handleClose, refetchDetails, enableFollowerCount = true }) => {
  const [followerCount, setFollowerCount] = useState({});
  const { success, error } = useNotiStack();
  const [loading, setLoading] = useState(false);
  const { data: categoriesList } = useCategories({ type: ['socials'] });

  const initialSocials = useMemo(() => {
    return formatCategoryValues(socialsValues);
  }, [socialsValues]);

  const handleChangeFollowerCount = (key, value) => {
    setFollowerCount((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (data) => {
    setLoading(true);
    const excludedSocials = socialsValues?.filter((item) => !item?.category?.meta?.showFollowerCount)?.map((item) => item?.categories_id);
    const socialsWithValues = Object.keys(data).filter(key => !!data[key] && !excludedSocials.includes(Number(key)));
    const followerCountWithoutValues = Object.entries(followerCount).find(([key, value]) => (value === "" && socialsWithValues?.includes(key)))?.[0] ?? null;

    if (removeNullValues(data)?.length < 1) {
      error('Add atleast one social media account.');
    } else if (enableFollowerCount && followerCountWithoutValues) {
      error('Follower count is required!');
    } else {
      const categories = Object.entries(data).map(([key, value]) => ({
        user_id: creatorDetails?.user_id,
        categories_id: Number(key),
        value: value,
        ...(enableFollowerCount && {
          meta: {
            ...socialsValues.find((item) => item?.categories_id === Number(key))?.meta ?? {},
            followerCount: parseInt(followerCount?.[Number(key)]) ?? null
          }
        })
      }));
      const response = await createOrUpdateCategoriesValues({
        current_step: VERIFY_FACE_ID_KEY,
        categories: categories,
        user_id: creatorDetails?.user_id,
      });
      if (response.ok) {
        success('Successfully updated socials!');
        handleClose();
        refetchDetails();
      }
    }
    setLoading(false);
  };

  const formik = useFormik({
    initialValues: initialSocials,
    enableReinitialize: true,
    onSubmit: (values) => handleSubmit(values)
  });

  useEffect(() => {
    if (enableFollowerCount) {
      const count = socialsValues?.reduce((acc, { categories_id, meta }) => {
        acc[categories_id] = meta?.followerCount ?? "";
        return acc;
      }, {});
      setFollowerCount(count);
    }
  }, [socialsValues, enableFollowerCount]);

  return (
    <Fragment>
      <PlatformsAndSocials
        formik={formik}
        fields={categoriesList}
        subTitle={'one (1) social media account'}
        {...(enableFollowerCount && {
          followerCount: followerCount,
          handleChangeFollowerCount: handleChangeFollowerCount
        })}
      />
      <EditProfileButtons
        handCancel={() => handleClose()}
        handleSubmit={() => formik?.handleSubmit()}
        loading={loading}
      />
    </Fragment>
  );
};